// src/components/TrackList.jsx
import React, { useEffect } from 'react';
import { useAudio } from '../../context/AudioProvider';
import { useOffCanvas } from '../../context/OffCanvasProvider';
import FeatureOptionsPanel from '../panels/FeatureOptionsPanel';

import swal from 'sweetalert';

import instrumental_icon from '../../assets/frontend/images/instrumental_icon.png';

const TrackList = ({ album, currentIndex, isPlaying, isPaused, onPlayTrack, onPauseTrack, onResumeTrack }) => {

    const {
        likedMap, toggleLikeTrack,
    } = useAudio();

    const { push: openCanvas } = useOffCanvas();  // load offcanvas functions

    const track = album && currentIndex !== null ? album.tracks[currentIndex] : null;

    // COMPUTED isLiked (replaces the old useState)
    const safeLikedMap = likedMap || [];

    const likedTracksArray =
        Array.isArray(safeLikedMap.tracks)
            ? safeLikedMap.tracks
            : []; // normalize

    useEffect(() => {
        if (album) {
            //loadTracklist(album, { startIndex: 0, autoPlay: false });
        }
    }, [album]);

    function openOptions(e, track) {
        e.stopPropagation();

        openCanvas({
            component: FeatureOptionsPanel,
            props: {
                track: track,
                tracklist: album,
            }
        });
    };
    function forceBlur(e) {
        const target = e.currentTarget;

        // The button will lose focus after 1/2 seconds
        if (target) {
            setTimeout(() => {
                requestAnimationFrame(() => {
                    target.blur();
                });
            }, 500);
        }
    }

    return (
        <ul className="tracklist">
            {album.tracks.map((track, index) => {
                const isLiked =
                    track?.random_id &&
                    likedTracksArray.some(item => item.random_id === track.random_id);
                return (
                    localStorage.getItem('user_playlist') ==='anissas_playlist' 
                    && (track.random_id  === 'i_cant_miss' || track.random_id === 'just_a_miss' || track.random_id  === 'no_need_for_words'
                    || track.random_id  === 'infinite_search_v1'  || track.random_id  === 'infinite_search_v2') ? (
                        <></>
                    ):(
                    <li key={index} className={`track ${index === currentIndex ? 'active' : ''} ${track.status !== 'active' ? 'inactive' : ''}`}>
                        <div className="horizontal-container">
                            <div className="horizontal-container justify-left bg-yellow"
                                onClick={() => {
                                    if (track.status !== 'active') {
                                        // show toast: not playable
                                        return;
                                    }
                                    if (index === currentIndex && !isPlaying) {
                                        onPlayTrack(index);
                                    } else if (index === currentIndex && isPlaying) {
                                        if (isPaused) {
                                            onResumeTrack();
                                        } else {
                                            onPauseTrack();
                                        }
                                    }else {
                                        onPlayTrack(index);
                                    }
                                }}>
                                <span className="">
                                    {index === currentIndex && isPlaying ? (
                                        <span className="colored-sound-bars" aria-hidden="true">
                                            <span className="bar"></span>
                                            <span className="bar"></span>
                                            <span className="bar"></span>
                                            <span className="bar"></span>
                                            <span className="bar"></span>
                                        </span>
                                    ) : (
                                        <span className="play-button" aria-label="Play"></span>
                                    )}
                                </span>
                                <span className="pl-5">
                                    <span className="font-orbitron font-size-18l-16m-14s font-weight-800 letter-spacing-0px italic">{track.title}</span>
                                </span>
                                {track.lyrics === '' && (
                                    <span className="pl-5">
                                        <img src={instrumental_icon} className="" alt="instrumental image" width="20" />
                                    </span>
                                )}
                                {track.type === 'demo' && (
                                    <span className="pl-5">
                                        <span className="font-poppins font-size-14 font-weight-400 letter-spacing-0px italic">(Demo)</span>
                                    </span>
                                )}
                                {track.type === 'prod' && (
                                    <span className="pl-5">
                                        <span className="font-poppins font-size-14 font-weight-400 letter-spacing-0px italic">(In Prod)</span>
                                    </span>
                                )}
                            </div>
                            <span className="align-right">
                                <div className="horizontal-container justify-right">
                                    <button className={`player-button-transparent liked ${isLiked ? 'active' : ''}`}
                                        tabIndex="-1"
                                        onPointerDown={(e) => e.preventDefault()}
                                        onPointerUp={(e) => {
                                            e.stopPropagation();
                                            toggleLikeTrack(track, album);

                                            // force blur on mobile
                                            forceBlur(e);
                                        }}
                                    >
                                    </button>
                                    <span className="pr-10"></span>
                                    <button className="track-button-transparent options" onClick={(e) => openOptions(e, track)}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </button>
                                </div>
                            </span>
                        </div>
                    </li >
                    )
                )
            })}
        </ul >
    );
};

export default TrackList;
